<div class="recently-played-game">
  <div class="recently-played-game__image-block">
    <img (click)="showPopup.emit($event)" class="game_icon" src="{{ gameImg }}" alt="game-image" />
    @if (notif) {
      <span class="recently-played-game__image-block__game-notification">{{ notif }}</span>
    }
  </div>
  <ion-progress-bar color="secondary" value="{{ played }}"></ion-progress-bar>
</div>
